
import notesAPI from '@/api/notes';
import checkForErrors from '@/helpers/checkForErrors';
import clientAPI from '@/api/clients';

export default {
  name: 'notesModal',
  props: {
    context: {
      type: String,
    },
    contextUuid: {
      type: String,
    },
    path: {
      type: String,
    },
    mode: {
      type: String,
    },
    note: {
      type: Object,
    },
    notable_type: {
      type: String,
    },
    notable_uuid: {
      type: String,
    },
    participants: {
      type: Array,
    },
  },

  data: () => {
    return {
      isWorking: false,
      editing: {},
      viewing: '',
      noteForm: {
        contents: '',
        notable_type: null,
        notable_uuid: null,
        case_uuid: null,
        task_uuid: null,
        plan_uuid: null,
        visible_to_clients: false,
        type: 'note',
        is_pinned: false,
      },
      client: {
        uuid: null,
        task_board_uuid: null,
      },
      linkTo: 'client',
    };
  },
  computed: {
    modalHeader() {
      return this.mode === 'overlay' ? 'Notes' : this.mode === 'create' ? 'Add new note ' : 'Edit note';
    },

    notable() {
      if (this.linkTo === 'client') {
        return { type: 'account', uuid: this.client.uuid };
      }
      if (this.linkTo === 'case') {
        return { type: 'case', uuid: this.noteForm.case_uuid };
      }
      if (this.linkTo === 'task') {
        return { type: 'task', uuid: this.noteForm.task_uuid };
      }
      if (this.linkTo === 'plan') {
        return { type: 'plan', uuid: this.noteForm.plan_uuid };
      }
      return { type: null, uuid: null };
    },
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },

    updateNote(note) {
      this.isWorking = true;

      if (note) {
        this.editing = { ...note };
      }
      notesAPI
        .updateNote(this.editing.uuid, this.editing)
        .then((rsp) => {
          this.$nuxt.$emit('notification', 'Note updated');
          this.$emit('edited');
          this.isWorking = false;

          if (this.mode === 'edit') {
            this.close();
          }
        })
        .catch((err) => {
          if (err.response.status === 403) {
            const message = 'This action is unauthorised.';
            this.$nuxt.$emit('confirm', {
              hideNoButton: true,
              message: message,
            });
            this.isWorking = false;
            if (this.mode === 'edit') {
              this.close();
            }
          } else {
            checkForErrors.process(err, this.$refs.formErrorPanel);
          }
        });
    },
    addNote() {
      const payload = {
        ...this.noteForm,
        notable_type: this.notable.type,
        notable_uuid: this.notable.uuid,
        contents: this.noteForm.contents,
        // stripped from payload for cases
        visible_to_clients: this.linkTo === 'case' ? undefined : this.noteForm.visible_to_clients,
      };
      notesAPI
        .postNotes(payload)
        .then((rsp) => {
          this.$nuxt.$emit('notification', 'Note added');
          this.form = {
            contents: '',
            notable_type: null,
            notable_uuid: null,
            case_uuid: null,
            task_uuid: null,
            plan_uuid: null,
            visible_to_clients: this.linkTo === 'case' ? undefined : false,
            type: 'note',
            is_pinned: false,
          };
          this.close();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            const message = err.response.data.message;
            this.$nuxt.$emit('confirm', {
              hideNoButton: true,
              message: message,
            });
            this.close();
          } else {
            checkForErrors.process(err, this.$refs.formErrorPanel);
          }
        });
    },
  },
  watch: {
    note: {
      deep: true,
      handler(new_val) {
        this.editing = Object.assign({}, new_val);
      },
    },
    'client.uuid': {
      handler(new_val) {
        clientAPI.getClient(new_val).then((rsp) => {
          this.client = rsp.data.data;
        });
      },
    },
  },
};
